// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Skeleton_wrapper__20o2o","medium":"Skeleton_medium__1EbMl","small":"Skeleton_small__1Cnqu","shine":"Skeleton_shine__19B3f"};